import styled from '@emotion/styled';
import { Checkbox as MUICheckbox } from '@mui/material';
import tw from 'twin.macro';

const ROOT_STYLES_BY_SIZE = {
  lg: tw`!w-8 !h-8`,
  xl: tw`!w-6 !h-6`,
};

const SVG_ICON_STYLES_BY_SIZE = {
  lg: tw`w-[19px] h-[19px]`,
  xl: tw`w-6 h-6`,
};

const getStyledCheckbox = size => styled(MUICheckbox)`
  ${tw`!p-0 text-base-600 shrink-0`}
  ${ROOT_STYLES_BY_SIZE[size]}

  .MuiSvgIcon-root {
    ${SVG_ICON_STYLES_BY_SIZE[size]}
  }

  &.Mui-checked {
    ${tw`text-brand-500`}
  }
`;

export const Checkbox = ({ size = 'lg', ...props }) => {
  const StyledCheckbox = getStyledCheckbox(size);

  return <StyledCheckbox disableRipple {...props} />;
};
